var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9429_6623",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9429_6623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 13.8333V2.14992H6.21675C6.32786 1.76103 6.55297 1.44436 6.89208 1.19992C7.23075 0.955474 7.60008 0.833252 8.00008 0.833252C8.4223 0.833252 8.80008 0.955474 9.13341 1.19992C9.46675 1.44436 9.68897 1.76103 9.80008 2.14992H13.8501V7.46659H12.6001V3.39992H11.2334V5.31659H4.78341V3.39992H3.41675V12.5833H6.80008V13.8333H2.16675ZM12.0001 13.9333L11.1334 13.0499L12.2334 11.9499H8.05008V10.6999H12.2334L11.1334 9.59992L12.0001 8.71659L14.6167 11.3333L12.0001 13.9333ZM8.01675 3.33325C8.18341 3.33325 8.32786 3.27214 8.45008 3.14992C8.5723 3.0277 8.63341 2.8777 8.63341 2.69992C8.63341 2.53325 8.5723 2.38881 8.45008 2.26659C8.32786 2.14436 8.18341 2.08325 8.01675 2.08325C7.83897 2.08325 7.68897 2.14436 7.56675 2.26659C7.44453 2.38881 7.38341 2.53325 7.38341 2.69992C7.38341 2.8777 7.44453 3.0277 7.56675 3.14992C7.68897 3.27214 7.83897 3.33325 8.01675 3.33325Z",
    fill: "white",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteIcon);
export default __webpack_public_path__ + "static/media/paste-icon.911842dbf0e983d64d5cad4e4b3a9837.svg";
export { ForwardRef as ReactComponent };